const NUMBER_OPTIONS = {
    EQUAL: { name: 'EQUAL', entity: 'number_filter.EQUAL' },
    MORE: { name: 'MORE', entity: 'number_filter.MORE' },
    LESS: { name: 'LESS', entity: 'number_filter.LESS' },
    RANGE: { name: 'RANGE', entity: 'number_filter.RANGE.title' }
};

export default NUMBER_OPTIONS;